import { createSlice } from "@reduxjs/toolkit";
import { ProjectType } from "../../types/organization/OrganizationList";
import { projectData } from "../../data/organization-list/OrganizationList";
import {productListTableData} from "../../data/organization/OrganizationList"


const initialState: ProjectType = {
  activeTab: "1",
  createdFormData: projectData,
};

const ProjectSlice = createSlice({
  name: "SideBarSlice",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setCreatedData: (state, action) => {
      state.createdFormData = action.payload;
    },
  },
});
export const { setActiveTab, setCreatedData } = ProjectSlice.actions;

export default ProjectSlice.reducer;